module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "订单编号"
    },
    model: {
      value: (_vm.filters.orderNO),
      callback: function($$v) {
        _vm.$set(_vm.filters, "orderNO", $$v)
      },
      expression: "filters.orderNO"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "商城订单号"
    },
    model: {
      value: (_vm.filters.mallOrderNO),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mallOrderNO", $$v)
      },
      expression: "filters.mallOrderNO"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "用户手机"
    },
    model: {
      value: (_vm.filters.userPhone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userPhone", $$v)
      },
      expression: "filters.userPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "用户省份"
    },
    model: {
      value: (_vm.filters.provinceIds),
      callback: function($$v) {
        _vm.$set(_vm.filters, "provinceIds", $$v)
      },
      expression: "filters.provinceIds"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.region_id,
      attrs: {
        "label": item.region_name,
        "value": item.region_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "picker-options": _vm.pickerOptions,
      "placeholder": "选择日期时间",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "完工码"
    },
    model: {
      value: (_vm.filters.finishCode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "finishCode", $$v)
      },
      expression: "filters.finishCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "工程师ID"
    },
    model: {
      value: (_vm.filters.masterId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "masterId", $$v)
      },
      expression: "filters.masterId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "用户姓名"
    },
    model: {
      value: (_vm.filters.userName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userName", $$v)
      },
      expression: "filters.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.accountType != 0) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "120px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商城用户ID"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.mallUserId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "商城订单号"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.mallOrderNO))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户姓名"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户电话"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userPhone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "详细地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userAddress))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商户详情"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryMerchant(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "付款方式"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatPayType")(props.row.payType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "物流信息"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.logistics))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.orderRemark))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户地区"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.regionAddress))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "指派员工"
          }
        }, [(typeof props.row.worker !== 'undefined') ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryCommonUser(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")]) : _c('span', [_vm._v("未派单")])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "工程师详情"
          }
        }, [(typeof props.row.masterId !== 'undefined') ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryMasterUser(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")]) : _c('span', [_vm._v("未指派")])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.installTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.productInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装图片"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryImage(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "车型"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.carType))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "产品信息"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.productInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.orderMoney)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "补贴备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.subsidyremark))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单状态"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.row.state)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "退订备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.cancelRemark))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单评分"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.score))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单评价"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.state))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "完工码"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.finishCode))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "orderNO",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchantId",
      "label": "商户ID",
      "formatter": _vm.formatMerchantId
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "merchantPayState",
      "label": "支付状态",
      "width": "100",
      "formatter": _vm.formatMerchantPayState
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderTime",
      "label": "订单时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderMoney",
      "label": "订单费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }), _vm._v(" "), (_vm.accountType == 0) ? _c('el-table-column', {
    attrs: {
      "prop": "installMoney",
      "label": "安装费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "subsidyMoney",
      "label": "补贴费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditOrder(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                ")]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.recoverOrder(scope.$index, scope.row)
            }
          }
        }, [_vm._v("恢复订单\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.rowCount,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑订单",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [(_vm.accountType == 1) ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "所属商户"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商户"
    },
    model: {
      value: (_vm.editForm.merchantId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "merchantId", $$v)
      },
      expression: "editForm.merchantId"
    }
  }, _vm._l((_vm.merchant), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.name,
        "value": item.userId
      }
    })
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "产品信息"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.productInfo),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "productInfo", $$v)
      },
      expression: "editForm.productInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车型"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.carType),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "carType", $$v)
      },
      expression: "editForm.carType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "订单费用"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "单位:元",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.orderMoney),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "orderMoney", $$v)
      },
      expression: "editForm.orderMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "安装费用"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "单位:元（可不填）",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.installMoney),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "installMoney", $$v)
      },
      expression: "editForm.installMoney"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "用户姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userName", $$v)
      },
      expression: "editForm.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "手机号码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userPhone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userPhone", $$v)
      },
      expression: "editForm.userPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "地区"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "255px"
    },
    attrs: {
      "placeholder": "不选择则使用之前地区",
      "options": _vm.addProvinces,
      "props": _vm.props
    },
    on: {
      "active-item-change": _vm.select_ChangeEvent
    },
    model: {
      value: (_vm.regionId),
      callback: function($$v) {
        _vm.regionId = $$v
      },
      expression: "regionId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userAddress", $$v)
      },
      expression: "editForm.userAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城ID"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mallUserId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mallUserId", $$v)
      },
      expression: "editForm.mallUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mallOrderNO),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mallOrderNO", $$v)
      },
      expression: "editForm.mallOrderNO"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流信息"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.logistics),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "logistics", $$v)
      },
      expression: "editForm.logistics"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "orderRemark", $$v)
      },
      expression: "editForm.orderRemark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "安装备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.installRemark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "installRemark", $$v)
      },
      expression: "editForm.installRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看图片",
      "close-on-click-modal": false,
      "customClass": "customWidth"
    },
    model: {
      value: (_vm.queryImageVisible),
      callback: function($$v) {
        _vm.queryImageVisible = $$v
      },
      expression: "queryImageVisible"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "门头相片"
    }
  }, _vm._l((_vm.images), function(item) {
    return _c('img', {
      attrs: {
        "src": item
      }
    })
  }), 0)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0874cd6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/cancelOrder.vue
// module id = 1077
// module chunks = 1